import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { backgroundRejectedByApprover } from '../../../../actions/backgroundActions'
import { objectivesRejectedByApprover } from '../../../../actions/objectivesActions'
import { audienceRejectedByApprover } from '../../../../actions/audienceActions'
import { projectTimelineRejectedByApprover } from '../../../../actions/projectTimelineActions'
import { documentRejectedByApprover } from '../../../../actions/supportingDocsActions'
import { documentApprovedByApprover } from '../../../../actions/projectTimelineActions'
import { stageCompleteStatusByApprover } from '../../../../actions/projectTimelineActions'
import { useDispatch } from "react-redux";
import { Modal,Button } from 'react-bootstrap';
import { useHistory } from "react-router";
const DisapproveModal = (props) => {

    const dispatch = useDispatch();
	const history = useHistory();
	const { register, handleSubmit, reset, setValue, formState: { errors, ...formState }} = useForm({
		mode: "onBlur",
	}),
	[inputReason, setInputReason] = useState(""),
	// [inputProjectId, setInputProjectId] = useState(""),
	[inputModalTitle, setInputModalTitle] = useState("");
	const { isValid } = formState

	const onAdminSubmit = async (values, e) => {
		if (props.data) {
			values.project_id = (props.data !== false) ? props.data : ''
		}
		if (props.component_id) {
			values.id = (props.component_id !== false) ? props.component_id : ''
		}
		if (props.component === "Timeline") {
			values.is_accept = false
		}
		if (props.component === "TimelineStageDocument") {
			values.document_id = props.data.id;
			values.project_id = props.data.project_id
			values.timeline_stage_id = props.data.stage_id
		}
		if (props.component === "TimelineStageStatus") {
			values.is_approved = false
			values.project_id = props.data.project_id
			values.timeline_stage_id = props.data.stage_id
		}
		console.log(values);
		var dispatchFunction
		if(props.component === "Background")  dispatchFunction = backgroundRejectedByApprover(values)
		else if(props.component === "Objectives") dispatchFunction = objectivesRejectedByApprover(values)
		else if(props.component === "Audience") dispatchFunction = audienceRejectedByApprover(values)
		else if(props.component === "Timeline") dispatchFunction = projectTimelineRejectedByApprover(values)
		else if(props.component === "SupportingDocs") dispatchFunction = documentRejectedByApprover(values)
		else if(props.component === "TimelineStageDocument") dispatchFunction = documentApprovedByApprover(values)
		else if(props.component === "TimelineStageStatus") dispatchFunction = stageCompleteStatusByApprover(values, history)
		else return false;
		dispatch(dispatchFunction);
		props.close();
	};

	useEffect(() => {
		// console.log("my disapprove props", props);
		if (props.data && props.data.mode === "edit") {
			// setValue('reject_reason', props.data.reason)
			// setInputReason(props.data.email);
			// setInputModalTitle("Edit Reason");
			//reset();
		} else {
			//console.log("within add");
			setValue('reject_reason', '')
			setInputReason("");
			// setInputProjectId(props.data)
			setInputModalTitle("Add Reason");
		}
	 }, [props, reset, setValue]);
	
	return (
		props.open && (
			<Modal show={props.open} onHide={props.close}>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title">{inputModalTitle}</Modal.Title>
					<Button variant="outline-danger" onClick={props.close}><i className="fa fa-close"></i></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-md-12">
						<form className="needs-validation" onSubmit={handleSubmit(onAdminSubmit)}>
							<div className="modal-body">
								<div className="form-group">
									<label>Enter Reason <span className="text-danger">*</span></label>
									<input
									  type="text"
									  className="form-control"
									  placeholder="Enter Reason"
									  tabIndex={1}
									  defaultValue={inputReason}
									  onChange={(e) => setInputReason(e.target.value)}
									  name="reject_reason"
									  autoComplete="off"
									  {...register('reject_reason', {
										required: "Reason is required",
										pattern: { value: /^[a-zA-Z ]*$/, message: "Only alphabates are allowed for this field" },
										maxLength: { value: 50, message: "reason max length is 50" }
									 }
									)} 
									/>	
									{errors.reject_reason && (
									<div className="text-danger">{errors.reject_reason.message}</div>
									)}
								</div>
								
							</div>  
							<div className="modal-footer">
								<button type="submit" className="btn button"  disabled={(props.data.mode !=='edit') && isValid}>Submit</button>
								<button type="button" className="btn btn-outline-danger p-2" data-dismiss="modal" onClick={props.close}>Cancel</button>
							</div>
						</form>
                    </div>
                </Modal.Body>
            </Modal> 
		)
	);
}

export default DisapproveModal;
